import { render, staticRenderFns } from "./InputBlock.vue?vue&type=template&id=c248a91c&"
import script from "./InputBlock.vue?vue&type=script&lang=js&"
export * from "./InputBlock.vue?vue&type=script&lang=js&"
import style0 from "./InputBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
